// extracted by mini-css-extract-plugin
export default {"notes":"Notes_notes__u47Ag","btn":"Notes_btn__l6OvD"};